/* mm-schritte.js — Magic Milk
 *
 * Sektion "Schritt fuer Schritt" nach Merts Vorlage (React-Baustein
 * FeatureSteps mit framer-motion, 19.08.2026): links eine Liste von
 * Schritten, von denen immer einer hell ist, rechts das dazu passende Bild,
 * das automatisch weiterwandert. Erledigte Schritte bekommen einen Haken.
 *
 * Nativ nachgebaut - im Shop laeuft kein React und kein framer-motion.
 * Uebernommen wurden aus der Vorlage: der Ablauf (Auto-Weiterschalten mit
 * Fortschritt), die Zweiteilung Liste/Bild, das Umschalten der Deckkraft auf
 * den aktiven Schritt, Haken statt Ziffer bei Erledigtem, und der Wechsel des
 * Bildes mit Verschieben und Aufblenden.
 *
 * BEWUSST NICHT uebernommen:
 *   - der Verlauf ueber dem Bild (bg-gradient-to-t). Dauerregel KEINE
 *     KI-OPTIK: keine Verlaeufe, kein Leuchten.
 *   - rotateX beim Bildwechsel. Auf einem Produktfoto wirkt das nach
 *     Effekt-Demo, nicht nach Laden.
 *
 * Aus den eigenen Sektionen uebernommen, weil dort teuer erkauft:
 *   1) #MainContent ist ein SPALTEN-Flexbereich - flex-basis ist dort die
 *      HOEHE und schlaegt jedes height. Deshalb flex:0 0 auto und die Breite
 *      ueber width/align-self.
 *   2) overflow:clip statt hidden, sonst waere position:sticky tot.
 *   3) EINE Uhr: ein Zeitstempel, ausgewertet von requestAnimationFrame UND
 *      einem setInterval als Ersatzantrieb. rAF steht still, sobald der
 *      Browser die Seite fuer verborgen haelt - mit rAF allein bewegte sich
 *      in der Vorschau gar nichts.
 *   4) Der Balken laeuft ueber transform:scaleX, nicht ueber width - width
 *      laesst den Browser bei jedem Schritt neu umbrechen und ruckelt.
 *   5) KEIN visibilitychange-Handler, der die Uhr zurueckstellt. Die
 *      Vorschau meldet 16 Sichtbarkeitswechsel in 5 Sekunden; die Standzeit
 *      kaeme nie durch.
 *
 * UMBAU 05.09.2026 auf das Design der AUREON-Startseite (Mert: „Schau, was bei
 * AUREON Startseite gemacht wurde und pass die Steps auch dem Design an die
 * Shopify Seite an.")
 * Uebernommen wurde von dort:
 *   - die senkrechte Zeitleiste: graue Grundschiene, darauf ein farbiger
 *     Balken, dessen Hoehe am Scrollfortschritt haengt
 *   - die Nummer als 01 bis 04 in einem abgerundeten Quadrat statt im Kreis
 *   - ein eigener Akzentton je Schritt (dieselben vier wie in der
 *     Punkte-Sektion, auf dem echten Untergrund nachgerechnet)
 *   - Trennlinie unter jedem Schritt, Titel hell erst wenn er dran ist
 *   - das Einblenden: was noch nicht dran war, steht versetzt und blass
 *
 * DER TAKTGEBER HAT GEWECHSELT: vorher schaltete eine Uhr alle vier Sekunden
 * weiter, jetzt entscheidet die Scrollposition, welcher Schritt dran ist -
 * genau wie bei AUREON. Beides zugleich ginge nicht: eine Uhr, die
 * weiterspringt, waehrend der Finger scrollt, laeuft dem Leser davon. Die
 * Fortschrittsspur je Zeile entfaellt damit ebenfalls, ihre Aufgabe
 * uebernimmt der Balken der Zeitleiste. Klicken bleibt: es springt zum
 * Schritt und setzt das Bild.
 *
 * Gruen ist raus. Es war hier Augenbraue, Haken und Fortschrittsfarbe, ist
 * laut Grundregeln aber Bedienfarbe und keine Schmuckfarbe.
 */
(function () {
  /* 21.08.2026, Mert: "diese section rein in produkt seite nicht in
     hauptseite". Lief vorher nur auf der Startseite. */
  if (window.location.pathname.indexOf('/products/') !== 0) return;

  var CDN = 'https://cdn.shopify.com/s/files/1/0958/0465/3955/files/';

  /* Ein Ton je Schritt, als RGB-Tripel weil derselbe Wert einmal voll und
     einmal durchscheinend gebraucht wird - ein Hex in einer CSS-Variablen
     laesst sich in rgba() nicht verwenden. Auf #151013 nachgerechnet:
     Rot 4,00:1 - Koralle 7,02:1 - Gold 10,48:1 - Rose 8,74:1, alle ueber der
     3:1-Schwelle fuer Grafik. Dieselbe Reihe wie in der Punkte-Sektion, damit
     die Seite eine Handschrift behaelt. */
  var TOENE = ['229,20,42', '255,115,85', '244,183,64', '255,143,168'];
  var AKZENT = '#E5142A';
  var WEICH = 'cubic-bezier(.22,.61,.36,1)';
  var FEDER = 'linear(0.0000,0.0572,0.1867,0.3424,0.4963,0.6332,0.7465,0.8350,0.9008,0.9472,0.9782,0.9974,1.0083,1.0134,1.0148,1.0140,1.0121,1.0098,1.0075,1.0055,1.0038,1.0025,1.0015,1.0008,1.0003,1.0000,0.9999)';

  var ruhig = false;
  try { ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Jeder Schritt zeigt GENAU das, was sein Text behauptet - die vier Bilder
     sind am 19.08. gegen die Shopify-Dateien geprueft (alle HTTP 200). */
  var SCHRITTE = [
    { nr: 'Schritt 1', titel: 'Einen Beutel nehmen',
      text: 'Drei\u00dfig einzelne Sachets liegen in der Box \u2014 Vorrat f\u00fcr einen Monat.',
      bild: CDN + 'mm-box-vorrat.jpg',
      alt: 'Drei\u00dfig einzelne Sachets in der Box' },
    { nr: 'Schritt 2', titel: 'In Wasser einr\u00fchren',
      text: '200 bis 250 ml lauwarmes Wasser, kurz umr\u00fchren, fertig.',
      bild: CDN + 'mm-box-ablauf.jpg',
      alt: 'Anwendung in drei Schritten' },
    { nr: 'Schritt 3', titel: 'Vor der Mahlzeit trinken',
      text: 'Einmal am Tag, am besten morgens vor dem ersten Essen.',
      bild: CDN + 'mm-box-zutaten.jpg',
      alt: 'Zehn pflanzliche Zutaten der Magic Milk Box' },
    { nr: 'Schritt 4', titel: 'Echtheit pr\u00fcfen',
      text: 'Vier Hologramm-Siegel auf der Packung \u2014 daran erkennst du das Original.',
      bild: CDN + 'mm-box-siegel.jpg',
      alt: 'Vier Hologramm-Siegel zur Echtheitspr\u00fcfung' }
  ];

  var css = [
    '#mmSchritte{flex:0 0 auto;align-self:stretch;width:100%;max-width:100%;',
    'min-width:0;box-sizing:border-box;margin:0;padding:clamp(56px,7vw,96px) 0;',
    'background:#151013;color:#F3E9EC;position:relative;overflow:clip}',
    '#mmSchritte *{box-sizing:border-box}',
    '#mmSchritte .mmSInnen{max-width:1000px;margin:0 auto;',
    'padding:0 clamp(16px,3vw,24px)}',

    '#mmSchritte .mmSAuge{font-size:.72rem;letter-spacing:.2em;',
    'text-transform:uppercase;color:' + AKZENT + ';margin:0 0 10px;font-weight:700}',
    '#mmSchritte h2{font-family:"Barlow Condensed",sans-serif;text-transform:uppercase;',
    'font-size:clamp(1.9rem,6vw,3rem);line-height:1;margin:0;font-weight:800;',
    'letter-spacing:-.01em;color:#F3E9EC}',
    '#mmSchritte .mmSTrenner{height:1px;background:rgba(243,233,236,.10);margin:20px 0}',

    '#mmSchritte .mmSRaster{display:grid;grid-template-columns:1fr;gap:22px}',
    '@media (min-width:760px){',
    '#mmSchritte .mmSRaster{grid-template-columns:1fr 1fr;',
    'gap:clamp(18px,3vw,34px);align-items:center}',
    '#mmSchritte .mmSBuehne{order:2}',
    '#mmSchritte .mmSListe{order:1}}',

    /* Bild - unveraendert, es traegt weiterhin den halben Inhalt. */
    '#mmSchritte .mmSBuehne{position:relative;border-radius:26px;overflow:hidden;',
    'border:1px solid rgba(243,233,236,.06);background:rgba(243,233,236,.05);',
    'aspect-ratio:4/3}',
    '#mmSchritte .mmSBild{position:absolute;inset:0;width:100%;height:100%;',
    'object-fit:cover;display:block;opacity:0;transform:translateY(18px);',
    'transition:opacity .5s ' + WEICH + ',transform .5s ' + WEICH + ';',
    'transition-timing-function:' + FEDER + '}',
    '#mmSchritte .mmSBild.da{opacity:1;transform:none}',

    /* --- Zeitleiste nach dem Vorbild der AUREON-Startseite ---------------
       Die Schiene liegt hinter den Marken, nicht zwischen ihnen: sie beginnt
       in der Mitte der ersten Marke und endet in der Mitte der letzten, sonst
       ragt oben und unten ein Stummel heraus. Beide Werte kommen aus
       denselben Variablen wie die Marke selbst, damit sie nicht auseinander
       laufen, wenn die Groesse sich aendert. */
    '#mmSchritte .mmSListe{--mmSMarke:40px;--mmSZeileMin:96px;',
    'position:relative;display:flex;flex-direction:column;gap:0;margin:0;',
    'padding:0;list-style:none}',
    '#mmSchritte .mmSSchiene{position:absolute;left:calc(var(--mmSMarke) / 2);',
    'top:calc(var(--mmSMarke) / 2);width:2px;border-radius:999px;overflow:hidden;',
    'background:rgba(243,233,236,.14);transform:translateX(-1px);',
    'opacity:0;transition:opacity .5s ease;pointer-events:none}',
    '#mmSchritte .mmSListe.mmSAn .mmSSchiene{opacity:1}',
    /* Der Farbbogen wird ueber die GANZE Schiene gespannt und nur aufgedeckt.
       Waere background-size an die wachsende Hoehe gebunden, haette jeder
       Stand denselben Farbausschnitt und die Farbe wanderte mit. */
    '#mmSchritte .mmSFluss{position:absolute;left:0;top:0;width:100%;height:0;',
    'display:block;border-radius:inherit;background:linear-gradient(to bottom,',
    'rgb(' + TOENE[0] + '),rgb(' + TOENE[1] + ') 34%,rgb(' + TOENE[2] + ') 67%,',
    'rgb(' + TOENE[3] + '));background-size:100% var(--mmSSchienenHoehe,100%);',
    'background-repeat:no-repeat}',

    /* --- eine Zeile --------------------------------------------------- */
    '#mmSchritte .mmSZeile{position:relative;z-index:1;display:block;width:100%;',
    'min-height:var(--mmSZeileMin);padding:2px 0 20px calc(var(--mmSMarke) + 20px);',
    'border:0;background:transparent;text-align:left;color:inherit;font:inherit;',
    'cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '#mmSchritte .mmSZeile:not(:last-child){',
    'border-bottom:1px solid rgba(243,233,236,.07)}',
    '#mmSchritte .mmSZeile + .mmSZeile{padding-top:20px}',
    '#mmSchritte .mmSZeile:focus-visible{outline:2px solid ' + AKZENT + ';',
    'outline-offset:3px;border-radius:12px}',

    /* Einblenden: was noch nicht dran war, steht blass und versetzt. Haengt
       an .mmSAn, und die Klasse setzt nur das Skript - ohne JavaScript steht
       jeder Schritt sofort vollstaendig da (Regel „keine leeren Felder"). */
    '#mmSchritte .mmSListe.mmSAn .mmSZeile{opacity:0;transform:translateY(22px)}',
    '#mmSchritte .mmSListe.mmSAn.mmSScharf .mmSZeile{',
    'transition:opacity .5s ' + WEICH + ',transform .5s ' + WEICH + '}',
    '#mmSchritte .mmSListe.mmSAn .mmSZeile.mmSWach{opacity:1;transform:none}',

    /* --- Marke: Nummer im abgerundeten Quadrat ------------------------- */
    '#mmSchritte .mmSMarke{position:absolute;left:0;top:2px;z-index:2;',
    'width:var(--mmSMarke);height:var(--mmSMarke);display:grid;place-items:center;',
    'border:1px solid rgba(243,233,236,.16);border-radius:11px;background:#151013;',
    'box-shadow:0 0 0 6px #151013;color:rgba(243,233,236,.5);',
    'font-family:"Barlow Condensed",sans-serif;font-size:.82rem;font-weight:800;',
    'letter-spacing:.04em;line-height:1;',
    'transition:color .34s ease,border-color .34s ease,background-color .34s ease,',
    'box-shadow .34s ease}',
    '#mmSchritte .mmSZeile + .mmSZeile .mmSMarke{top:22px}',
    '#mmSchritte .mmSZeile.mmSWach .mmSMarke{color:rgb(var(--mmSTon));',
    'border-color:rgba(var(--mmSTon),.7);background:#1B1013;',
    'box-shadow:0 0 0 6px #151013,0 0 22px -8px rgba(var(--mmSTon),.9)}',
    '#mmSchritte .mmSZeile[aria-current="true"] .mmSMarke{',
    'animation:mmSPop .5s cubic-bezier(.2,.9,.24,1.2) both}',
    '@keyframes mmSPop{0%{transform:scale(.8)}56%{transform:scale(1.11)}',
    '100%{transform:scale(1)}}',

    /* Der kurze Schein beim Aktivieren - einfarbig und sehr kurz, damit es
       nicht nach Effekt-Demo aussieht. */
    '#mmSchritte .mmSSchein{position:absolute;left:-8px;top:-6px;z-index:1;',
    'width:calc(var(--mmSMarke) + 16px);height:calc(var(--mmSMarke) + 16px);',
    'border-radius:16px;opacity:0;pointer-events:none;',
    'background:radial-gradient(circle,rgba(var(--mmSTon),.5) 0%,transparent 70%)}',
    '#mmSchritte .mmSZeile + .mmSZeile .mmSSchein{top:14px}',
    '#mmSchritte .mmSZeile[aria-current="true"] .mmSSchein{',
    'animation:mmSSchein .7s ' + WEICH + ' both}',
    '@keyframes mmSSchein{0%{opacity:0;transform:scale(.6)}',
    '38%{opacity:.7}100%{opacity:0;transform:scale(1.5)}}',

    '#mmSchritte .mmSText{display:block;min-width:0}',
    '#mmSchritte .mmSTitel{display:block;font-family:"Barlow Condensed",sans-serif;',
    'text-transform:uppercase;font-size:clamp(1.1rem,4.4vw,1.4rem);',
    'line-height:1.1;letter-spacing:-.01em;font-weight:800;',
    'color:rgba(243,233,236,.5);transition:color .34s ease}',
    '#mmSchritte .mmSZeile.mmSWach .mmSTitel{color:#F3E9EC}',
    '#mmSchritte .mmSAbsatz{display:block;margin-top:6px;font-size:.9rem;',
    'line-height:1.55;color:rgba(243,233,236,.55);max-width:46ch}',

    '@media (prefers-reduced-motion:reduce){',
    '#mmSchritte .mmSBild,#mmSchritte .mmSMarke,#mmSchritte .mmSTitel{',
    'transition:none!important}',
    '#mmSchritte .mmSListe.mmSAn .mmSZeile{opacity:1!important;transform:none!important}',
    '#mmSchritte .mmSMarke{animation:none!important}',
    '#mmSchritte .mmSSchein{display:none!important}}'
  ].join('');

  function stil() {
    if (document.getElementById('mmSchritte-stil')) return;
    var s = document.createElement('style');
    s.id = 'mmSchritte-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function bauen() {
    if (document.getElementById('mmSchritte')) return true;
    /* Hinter die Sektion "Was passt zu dir" - erst waehlt man das Produkt,
       dann liest man, wie es benutzt wird. Faellt die zurueck, wird die
       Kachelreihe als Anker genommen. */
    /* 05.09.2026 gemessen: die frueheren Anker `#mmPro` und `#mmHigh` gibt es
       auf der Produktseite nicht mehr - das Skript lud, fand keinen Platz und
       die Sektion war unsichtbar, schon vor dem Umbau auf das AUREON-Design.
       Deshalb eine Kette echter, gepruefter Anker: nach „Vier Saetze, die wir
       jeden Tag hoeren" ist der richtige Ort, dort ist das Problem erklaert
       und die Anwendung die naechste Frage. */
    var anker = document.getElementById('mmPu') ||
                document.getElementById('mmWi') ||
                document.getElementById('mmProdukt') ||
                document.getElementById('mmPro') ||
                document.getElementById('mmHigh');
    if (!anker || !anker.parentNode) return false;
    stil();

    var sek = document.createElement('section');
    sek.id = 'mmSchritte';
    sek.innerHTML =
      '<div class="mmSInnen">' +
        '<p class="mmSAuge">So geht es</p>' +
        '<h2>Schritt f\u00fcr Schritt</h2>' +
        '<div class="mmSTrenner"></div>' +
        '<div class="mmSRaster">' +
          '<div class="mmSBuehne">' +
            SCHRITTE.map(function (s, i) {
              return '<img class="mmSBild' + (i === 0 ? ' da' : '') + '" src="' +
                s.bild + '?width=900" alt="' + s.alt + '" decoding="async">';
            }).join('') +
          '</div>' +
          '<div class="mmSListe">' +
            '<span class="mmSSchiene" aria-hidden="true"><span class="mmSFluss"></span></span>' +
            SCHRITTE.map(function (s, i) {
              /* Bewusst KEIN <h3> und keine Listenrolle im <button>: ein
                 Knopf nimmt laut HTML nur Textinhalt auf, eine Ueberschrift
                 ist Flussinhalt, und role="listitem" wuerde die Knopfrolle
                 ueberschreiben. Browser zeigen beides, Vorlesehilfen
                 stolpern. Der Titel ist deshalb ein <span>, optisch gleich.
                 Die Nummer steht zweistellig (01 statt 1) wie bei AUREON -
                 als Text und nicht als CSS-Counter, weil ein Counter fuer
                 Vorlesehilfen nicht existiert. */
              return '<button type="button" class="mmSZeile" ' +
                'style="--mmSTon:' + TOENE[i % TOENE.length] + '" ' +
                'aria-current="' + (i === 0) + '">' +
                '<span class="mmSSchein" aria-hidden="true"></span>' +
                '<span class="mmSMarke" aria-hidden="true">' +
                  (i + 1 < 10 ? '0' : '') + (i + 1) + '</span>' +
                '<span class="mmSText"><span class="mmSTitel">' + s.titel + '</span>' +
                '<span class="mmSAbsatz">' + s.text + '</span></span>' +
                '</button>';
            }).join('') +
          '</div>' +
        '</div>' +
      '</div>';

    anker.parentNode.insertBefore(sek, anker.nextSibling);

    var bilder = [].slice.call(sek.querySelectorAll('.mmSBild'));
    var zeilen = [].slice.call(sek.querySelectorAll('.mmSZeile'));
    var liste = sek.querySelector('.mmSListe');
    var schiene = sek.querySelector('.mmSSchiene');
    var fluss = sek.querySelector('.mmSFluss');
    var schritt_i = -1;

    /* Nur das Bild und die Kennzeichnung - welcher Schritt WACH ist,
       entscheidet der Scrollstand weiter unten. */
    function zeigen(neu) {
      var n = SCHRITTE.length;
      neu = ((neu % n) + n) % n;
      if (neu === schritt_i) return;
      schritt_i = neu;
      bilder.forEach(function (b, i) { b.classList.toggle('da', i === schritt_i); });
      zeilen.forEach(function (z, i) {
        z.setAttribute('aria-current', String(i === schritt_i));
      });
    }

    /* Klick springt zum Schritt: Bild setzen und alles bis dorthin aufdecken.
       Wer klickt, will es sehen - nicht erst weiterscrollen muessen. */
    liste.addEventListener('click', function (e) {
      var z = e.target.closest ? e.target.closest('.mmSZeile') : null;
      if (!z) return;
      e.preventDefault();
      var i = zeilen.indexOf(z);
      if (i < 0) return;
      zeilen.forEach(function (x, k) { x.classList.toggle('mmSWach', k <= i); });
      zeigen(i);
      strichZiehen(i);
    });

    /* Die Schiene laeuft von der Mitte der ersten bis zur Mitte der letzten
       Marke. Beide Punkte werden am Element GEMESSEN und nicht aus Abstaenden
       zusammengerechnet: die Marke sitzt in der ersten Zeile anders als in den
       folgenden (dort schiebt das Innenabstand-Plus sie um 22 Pixel nach
       unten). Zwei getrennte Rechnungen liefen genau darum auseinander - der
       Balken blieb 22 Pixel vor dem Ende stehen. */
    function markenMitte(zeile) {
      var m = zeile.querySelector('.mmSMarke');
      if (!m) return zeile.offsetTop;
      /* Beide Werte addieren: die Marke steht absolut IN der Zeile, ihr
         offsetTop zaehlt deshalb ab der Zeile (2 px oben, 22 px in allen
         folgenden) und nicht ab der Liste. Ohne die Zeilenposition kam eine
         Schiene von 20 Pixeln heraus statt 746. */
      return zeile.offsetTop + m.offsetTop + m.offsetHeight / 2;
    }

    function schieneMessen() {
      if (!zeilen.length) return 0;
      var oben = markenMitte(zeilen[0]);
      var unten = markenMitte(zeilen[zeilen.length - 1]);
      var hoehe = Math.max(1, unten - oben);
      schiene.style.top = oben + 'px';
      schiene.style.height = hoehe + 'px';
      fluss.style.setProperty('--mmSSchienenHoehe', hoehe + 'px');
      return hoehe;
    }

    function strichZiehen(bisIndex) {
      var hoehe = schieneMessen();
      var oben = markenMitte(zeilen[0]);
      var bis = markenMitte(zeilen[Math.max(0, Math.min(zeilen.length - 1, bisIndex))]);
      fluss.style.height = Math.max(0, Math.min(hoehe, bis - oben)) + 'px';
    }

    /* --- Scrollstand statt Uhr -------------------------------------------
       Dieselben Marken wie bei AUREON: ein Schritt wird wach, sobald seine
       Marke die Hoehe erreicht, auf der man ihn auch liest. 78 % der
       Fensterhoehe ist knapp ueber dem unteren Rand - frueh genug, dass
       niemand auf Text wartet, spaet genug, dass nicht alles auf einmal da
       ist. Der Balken folgt derselben Rechnung, damit Farbe und Text nie
       auseinanderlaufen. */
    var geplant = false;
    function rechnen() {
      geplant = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 1;
      var linie = vh * 0.78;
      var letzterWacher = -1;

      /* Der Abstand vom Listenanfang bis zur Marke - einmal im Dokument
         (fuer die Balkenhoehe) und einmal im Fenster (fuer die Frage, ob der
         Schritt schon dran ist). */
      var listeOben = liste.getBoundingClientRect().top;
      zeilen.forEach(function (z, i) {
        var imFenster = listeOben + markenMitte(z);
        var wach = imFenster <= linie;
        z.classList.toggle('mmSWach', wach);
        if (wach) letzterWacher = i;
      });

      var hoehe = schieneMessen();
      var nullpunkt = markenMitte(zeilen[0]);

      if (letzterWacher < 0) {
        fluss.style.height = '0px';
      } else {
        /* Zwischen zwei Marken waechst der Balken anteilig weiter, sonst
           springt er in Stufen und wirkt abgehackt. */
        var basis = markenMitte(zeilen[letzterWacher]) - nullpunkt;
        var naechste = zeilen[letzterWacher + 1];
        if (naechste) {
          var von = listeOben + markenMitte(zeilen[letzterWacher]);
          var bis = listeOben + markenMitte(naechste);
          var strecke = Math.max(1, bis - von);
          var anteil = Math.max(0, Math.min(1, (linie - von) / strecke));
          basis += anteil * (markenMitte(naechste) - markenMitte(zeilen[letzterWacher]));
        }
        fluss.style.height = Math.min(hoehe, Math.max(0, basis)) + 'px';
        if (letzterWacher !== schritt_i) zeigen(letzterWacher);
      }
    }

    function planen() {
      if (geplant || document.hidden) return;
      geplant = true;
      window.requestAnimationFrame(rechnen);
    }

    zeigen(0);

    if (ruhig) {
      /* Ohne Bewegung steht alles sofort vollstaendig da. */
      zeilen.forEach(function (z) { z.classList.add('mmSWach'); });
      liste.classList.add('mmSAn');
      strichZiehen(zeilen.length - 1);
      return true;
    }

    liste.classList.add('mmSAn');
    /* Die Uebergaenge kommen einen Frame spaeter dazu, sonst laeuft beim
       Laden eine Blende von sichtbar nach unsichtbar und alle vier Schritte
       blitzen kurz auf. setTimeout als zweiter Weg, weil
       requestAnimationFrame in einem verborgenen Tab gar nicht laeuft. */
    var scharf = false;
    function scharfMachen() {
      if (scharf) return;
      scharf = true;
      liste.classList.add('mmSScharf');
    }
    window.requestAnimationFrame(scharfMachen);
    window.setTimeout(scharfMachen, 60);

    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) planen();
    });
    /* Erster Stand ohne auf ein Scrollereignis zu warten - wieder auf beiden
       Wegen, aus demselben Grund wie oben. */
    window.requestAnimationFrame(rechnen);
    window.setTimeout(function () { if (!geplant) rechnen(); }, 80);

    return true;
  }

  function start() {
    if (bauen()) return;
    /* Die Zielsektionen entstehen selbst erst per Skript, teils spaet. Statt
       blind zu wiederholen wird auf ihr Auftauchen gewartet; der Zaehler
       bleibt als zweiter Weg, falls der Beobachter nichts meldet. */
    var fertig = false;
    var wache = null;
    if (window.MutationObserver) {
      wache = new window.MutationObserver(function () {
        if (!fertig && bauen()) { fertig = true; wache.disconnect(); }
      });
      wache.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { if (wache) wache.disconnect(); }, 20000);
    }
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (fertig || bauen() || n > 24) {
        fertig = true;
        clearInterval(t);
        if (wache) wache.disconnect();
      }
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
  window.addEventListener('load', start);
})();
